var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingMydashboardBlackOnTransparant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-640 -200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M677.308 249.867 680.975 249.867 680.975 229.379 677.308 229.379 677.308 249.867ZM668.463 249.867 672.129 249.867 672.129 236.896 668.463 236.896 668.463 249.867ZM718.971 209.35 649.029 209.35C646.004 209.35 643.529 211.825 643.529 214.85L643.529 262.379C643.529 265.404 646.004 267.879 649.029 267.879L676.529 267.879 676.529 274.983 662.963 274.983 662.963 278.65 705.037 278.65 705.037 274.983 691.471 274.983 691.471 267.879 718.971 267.879C721.996 267.879 724.471 265.404 724.471 262.379L724.471 214.85C724.471 211.825 721.996 209.35 718.971 209.35ZM687.804 274.983 680.196 274.983 680.196 267.879 687.804 267.879 687.804 274.983ZM720.804 262.379C720.804 263.388 719.979 264.212 718.971 264.212L649.029 264.212C648.021 264.212 647.196 263.388 647.196 262.379L647.196 259.95 715.304 259.95 715.304 256.283 647.196 256.283 647.196 214.85C647.196 213.842 648.021 213.017 649.029 213.017L718.971 213.017C719.979 213.017 720.804 213.842 720.804 214.85L720.804 262.379ZM686.567 249.867 690.233 249.867 690.233 219.8 686.567 219.8 686.567 249.867ZM695.871 249.867 699.537 249.867 699.537 229.379 695.871 229.379 695.871 249.867Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingMydashboardBlackOnTransparant);
export default __webpack_public_path__ + "static/media/landing_mydashboard_black_on_transparant.0648e1419e95c9decf0e3643c1e8b428.svg";
export { ForwardRef as ReactComponent };